var _defs, _rect, _rect2, _rect3, _circle, _circle2, _circle3, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSchluesselkaesten = function SvgSchluesselkaesten(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74.964,
    height: 85.063
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "schluesselkaesten_svg__a",
    x1: 7.212,
    x2: 17.451,
    y1: 42.531,
    y2: 42.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4f4f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bcc8cc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "schluesselkaesten_svg__b",
    x1: 3.309,
    x2: 71.655,
    y1: 51.356,
    y2: 51.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ebene 2",
    style: {
      isolation: "isolate"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 85.063,
    height: 74.964,
    x: -5.05,
    y: 5.05,
    fill: "#bcc8cc",
    rx: 6,
    transform: "rotate(90 37.482 42.532)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 70.552,
    height: 80.448,
    x: 2.206,
    y: 2.308,
    fill: "#4c6f73",
    rx: 4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 78.141,
    height: 68.346,
    x: -1.589,
    y: 8.358,
    fill: "#a0b2b6",
    rx: 3,
    transform: "rotate(90 37.482 42.531)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.331,
    cy: 42.531,
    r: 5.12,
    fill: "url(#schluesselkaesten_svg__a)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.331,
    cy: 42.531,
    r: 4.283,
    fill: "#688589"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.331,
    cy: 42.531,
    r: 3.865,
    fill: "#d8dee2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#093a3e",
    d: "M11.676 40.476h1.311v4.112h-1.311z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f4f4f8",
    d: "m3.309 68.3-.134-15.437-.049-15.438L3.055 6.52A3.73 3.73 0 0 1 5.402 3.41a4.8 4.8 0 0 1 1.91-.22l1.846.005 7.379.025 14.758.048 14.758.05 14.758.142-14.758.141-14.758.05-14.758.05-7.38.024-1.844.006a4.3 4.3 0 0 0-1.73.2 3.18 3.18 0 0 0-1.98 2.65l-.111 30.843-.05 15.438Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#schluesselkaesten_svg__b)",
    d: "M3.309 35.076v22.918c26.892-10.186 50.664-1.986 68.346 9.642V39.904c-19.627.157-47.949-2.531-68.346-4.828",
    style: {
      mixBlendMode: "soft-light"
    }
  })));
};
export default SvgSchluesselkaesten;